export function finalizeTerminalErrorMessages(messages, frame, timestamp = new Date().toISOString()) {
  const updated = [...messages];
  const index = updated.findLastIndex((message) => (
    message.streaming && (!frame.requestId || message.requestId === frame.requestId)
  ));

  if (index >= 0) {
    const placeholder = updated[index];
    if (placeholder.content?.trim()) {
      updated[index] = { ...placeholder, streaming: false, checking: null };
    } else {
      updated.splice(index, 1);
    }
  }

  updated.push({
    role: "system",
    content: `Error: ${frame.message}`,
    timestamp,
    terminalError: true,
    ...(frame.requestId ? { requestId: frame.requestId } : {}),
  });
  return updated;
}